import { JumpToModule } from './../../../widgets/jump-to/jump-to.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	DxDataGridModule, DxChartModule, DxBulletModule, DxTemplateModule, DxPopupModule, DxPivotGridModule, DxAutocompleteModule, DxTreeListModule, DxDropDownButtonModule,

} from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import { CapacityService } from '../capacity.service';
import { DxoFieldChooserModule, DxoScrollingModule } from 'devextreme-angular/ui/nested';
import { CapacityDeepDiveComponent } from './capacity-deep-dive.component';
import { CapacityDeepDiveRoutingModule } from './capacity-deep-dive-routing.module';
import { InfoHeaderModule } from 'src/app/widgets/info-header/info-header.module';
import { AutocompleteComponent } from 'src/app/widgets';
import { DxTableControllerDirective } from 'src/app/directives/dx-table-controller.directive';
import { ContainerComponent } from 'src/app/components/container/container.component';



@NgModule({
	declarations: [CapacityDeepDiveComponent],
	imports: [
		CommonModule,
		CapacityDeepDiveRoutingModule,

		JumpToModule,
		DxTableControllerDirective,
		ContainerComponent,

		DxDataGridModule,
		DxChartModule,
		DevEpressCommonModule,
		DxDataGridModule,
		DxBulletModule,
		DxTemplateModule,
		DxPopupModule,
		DxPivotGridModule,
		DxoFieldChooserModule,
		DxoScrollingModule,
		AutocompleteComponent,
		DxAutocompleteModule,
		InfoHeaderModule,
		DxTreeListModule,
		DxPopupModule,
		DxDropDownButtonModule
	], providers: [CapacityService]
})
export class CapacityDeepDiveModule { }
